import ReactDOM from 'react-dom/client';
import './styles.css';
import * as Sentry from '@sentry/react';
import { env, isLocal, loadRuntimeConfig } from '@/config';
import { scrubBreadcrumb, scrubEvent } from '@/lib/sentryScrub';

void (async () => {
  // Load /config.json before importing any module that reads config at
  // module-evaluation time (notably src/api/api.ts which constructs the
  // ky client with the current apiUrl). docs/RELEASE_FLOW.md §13.
  await loadRuntimeConfig();

  Sentry.init({
    dsn: 'https://e4a3c40bde4b30e43460a795ded374d7@o4510147544350720.ingest.us.sentry.io/4510147548151808',
    sendDefaultPii: false,
    environment: env,
    enabled: !isLocal,
    // Strip PHI/PII before anything leaves the browser: drop query strings from
    // breadcrumb/event URLs, drop console + DOM breadcrumbs, mask sensitive keys
    // in free text. (Cyb-011)
    beforeBreadcrumb: scrubBreadcrumb,
    beforeSend: scrubEvent,
  });

  // Dynamic import is intentional: it forces Providers (and api/api.ts
  // transitively) to be evaluated AFTER loadRuntimeConfig() has populated
  // the config exports. A static import would evaluate api/api.ts at
  // module-graph load, which happens before this IIFE runs.
  const { Providers } = await import('./providers');

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const rootElement = document.getElementById('app')!;
  if (!rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(<Providers />);
  }
})();
